export const blockIconsActivitiesArchitectureNew = (
	<span className='material-symbols-outlined'>architecture</span>
);
